<template>
    <div class="home">
        <b-container fluid>
            <b-row>
              <b-col>
                <h1>Application Messages</h1>
              </b-col>
            </b-row>

            <div class="card">
              <div class="card-header">Messages</div>
              <div class="card-body">
                  <b-row class="mt-2">
                      <b-col cols="12">
                          <p style="font-weight:750;" class="mb-1">Messages Sent/Received</p>
                          <b-table hover small show-empty class="sr-caption"
                                   aria-live="polite"
                                   responsive="true"
                                   :fields="extNoteFields"
                                   :items="application.externalNotes"
                                   :busy="false"
                                   label-sort-asc=""
                                   label-sort-desc=""
                                   caption="Messages Sent/Received table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                              <template v-slot:no-data>
                                  No Notes Found.
                              </template>
                              <div slot="table-busy" class="text-center text-danger my-2">
                                  <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                                  <strong>Loading...</strong>
                              </div>
                              <template slot="empty" slot-scope="scope">
                                  No Notes Found.
                              </template>
                          </b-table>
                      </b-col>
                  </b-row>

                  <b-row class="mt-3" v-if="!isFrozen">
                    <b-col cols="12">
                      <BaseParagraphInput v-model="comments" 
                          :v="$v.comments"
                          label="Message"
                          slug="comments"
                          tip=""
                          setId="comments"
                      />
                    </b-col>
                  </b-row>

                  <b-row class="mt-1" v-if="!isFrozen">
                    <b-col cols="12">
                        <b-button variant="link" class="mr-4" @click="send">Send</b-button>
                    </b-col>
                  </b-row>
              </div>
            </div>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import { required, maxLength } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {

  data: () => ({
    application: {},
    comments: null,
    extNoteFields: [
        {key: 'note', sortable: true, label: 'Note'},
        {key: 'noteDate', sortable: true, label: 'Note Date'},
        {key: 'noteByName', sortable: true, label: 'Note By'}
    ],
  }),
  
  mounted() {
    this.loadApplication()
  },

  computed: {
    isFrozen: function() {
      return this.application.applicationStatus !== 'PENDING';
    }
  },

  validations: {
    comments: { required: false, maxLength: maxLength(4000) }
  },

  methods: {
    loadApplication() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/${this.$route.params.id}`)
        .then(response => { 
          this.application = response.data
        })
    },

    send() {
      const payload = {
        applicationId: this.$route.params.id,
        publicNotes: this.comments
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/application/extMsg/false`, payload)
        .then(response => {
            this.showRootToast("Application Updates", "The messages have been updated.", "success")
            if (!this.application.externalNotes) {
                this.application.externalNotes = []
            }
            this.application.externalNotes.push({
                noteType: {
                    description: "From Applicant"
                },
                note: this.comments,
                noteDate: moment().format('YYYY-MM-DD'),
                noteByName: "Me"
            })
            this.comments = null
      })
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
            title: title,
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: type,
           appendToast: true,
            noAutoHide:true
          })
        this.toastFocus()
    },
    toastFocus() {
        setTimeout(() => {
            let elem = document.getElementsByClassName("toast")
            elem = elem[elem.length-1]
            elem.focus()
        }, 100)
    },
  },

  created() {
    document.title = "Application Messages - Body Art"
  }
}
</script>

<style>
</style>